module.exports = __webpack_public_path__ + "img/mart3.b6844a6d.jpeg";